import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function StressPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboardingV2.stress.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-blue"
          emoji="📱"
          label={t("pages.onboardingV2.stress.scrollPhone")}
          name={t("pages.onboardingV2.stress.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV2.stress.scrollPhone", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="🍫"
          label={t("pages.onboardingV2.stress.eat")}
          name={t("pages.onboardingV2.stress.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV2.stress.eat", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-green"
          emoji="🏃"
          label={t("pages.onboardingV2.stress.exercise")}
          name={t("pages.onboardingV2.stress.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV2.stress.exercise", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="💬"
          label={t("pages.onboardingV2.stress.talkToSomeone")}
          name={t("pages.onboardingV2.stress.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV2.stress.talkToSomeone", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-orange"
          emoji="🤐"
          label={t("pages.onboardingV2.stress.keepItIn")}
          name={t("pages.onboardingV2.stress.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV2.stress.keepItIn", { lng: "en" })}
        />
      </Form>
    </Layout>
  )
}
